<template>
    <a :href="`${possibleLangPrefix}/weekmenu/${content.slug}`" class="block-img-hover block">
        <div class="relative">
            <div class="w-full h-[400px] sm:h-[280px] md:h-[400px] mb-md" v-if="content.acf.image">
                <picture class="absolute top-0 left-0 h-full w-full">
                    <img :data-src="content.acf.image.url" :alt="content.title.rendered" class="w-full h-full object-cover lazyload" />
                </picture>
            </div>
            <div class="block-img-hover__icon">
                <i class="fa-regular fa-arrow-right"></i>
            </div>
        </div>
        <div>
            <h3 v-html="content.title.rendered"></h3>           
        </div>
    </a>
</template>

<script>
export default {
    name: 'weekmenuitem',
    props: ['content'],

    computed: {
        possibleLangPrefix() {
            // prefix with lang other than nl for correct Weglot translations
            return document.documentElement.lang !== 'nl' ? `/${document.documentElement.lang}` : '';
        },
    },
};
</script>
